import { render } from "./OtiActions.vue?vue&type=template&id=5fc90182&scoped=true"
import script from "./OtiActions.vue?vue&type=script&lang=js"
export * from "./OtiActions.vue?vue&type=script&lang=js"

import "./OtiActions.vue?vue&type=style&index=0&id=5fc90182&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc90182"]])

export default __exports__